import * as React from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Tabs,
  Tab,
  Rating,
} from "@mui/material";

import Pusher from "pusher-js";
import { Add, Close as CloseIcon } from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Breadcrumbs } from "@mui/material";
import { Link } from "react-router-dom";
import Wrapper from "../../../components/TenantWrapper";
import title from "../../../components/title";
import { useFormik } from "formik";
import { maintenanceRequestValidationSchema } from "./maintenanceRequestValidation";
import { BASE_URL } from "../../../config/config";
import { ToastContainer, toast } from "react-toastify";
import { GetAllTenantMaintenanceRequest } from "../../../redux/reducer/GetAllTenantMaintenanceRequest";
import { MaintenanceRequestTenant } from "../../../redux/reducer/MaintenanceRequestTenant";
import { Drawer } from "@mui/material";
import { Send as SendIcon } from "@mui/icons-material";
import { SendChat } from "../../../redux/reducer/SendChat";
import { GetAllMaintenanceRequestChat } from "../../../redux/reducer/GetMaintenanceRequestChat";
import {RequestResponseLandlord} from "../../../redux/reducer/RequestResponseLandlord";
import DescriptionCell from "../../../components/Description";
import ImageZoomModal from "../../../components/ImageZoomModal";
import RecordNotFound from "../../../components/RecordNotFound";
const userID = localStorage.getItem("user_id");

const token = sessionStorage.getItem("ots_token");

export default function TenantMaintenanceRequest() {
  const open = useSelector((state) => state.sidebar.open);
  const requests = useSelector(
    (state) => state?.tenantMaintenanceRequest?.GetTenantMaintenanceAll?.data
  );
  const requestSendLoading = useSelector(
    (state) => state?.CreateTenantMaintenanceRequest?.loading
  );
  const loadingRequests = useSelector(
    (state) => state?.tenantMaintenanceRequest?.loading
  );
  const data = useSelector(
    (state) => state?.maintenanceRequestChat?.GetMaintenanceChat
  );
  title("Maintenance Request");

  const location = useLocation();
  const mylocation = location.pathname;
  const dispatch = useDispatch();
  const getId = window.location.pathname.replace(
    "/tenant-maintenance-request/",
    ""
  );
  const [tenantId, flatId] = getId.split("/");
  // const [requests, setRequests] = useState([]);
  // const [loadingRequests, setLoadingRequests] = useState(false);

  const [tab, setTab] = useState(0); // 0: All, 1: Pending, 2: In Progress, 3: Completed

  const [openModal, setOpenModal] = useState(false);
  const [openIssueResolved, setOpenIssueResolved] = useState(false);
  const [rating, setRating] = useState(0);
  const [loading, setLoading] = useState(false);

  const statusLabels = ["all", "pending", "accepted", "completed","rejected"];
  const [replyModal, setReplyModal] = useState(false);
  const selectedReq = null;
  const [activeChat] = useState({
    requestId: "",
    messages: [], // [{ sender: "owner", text: "Hello" }]
  });
  const [openChatSidebar, setOpenChatSidebar] = useState(false);
  const [pusherChannel, setPusherChannel] = useState(null);
  const [pusherClient, setPusherClient] = useState(null);
  const [chatMessage, setChatMessage] = useState("");
  const [messages, setMessages] = useState({});
  const [chatLoading, setChatLoading] = useState(false);
  // ADD STATE at top inside component
const [zoomOpen, setZoomOpen] = useState(false);
const [zoomImages, setZoomImages] = useState([]);
const [zoomIndex, setZoomIndex] = useState(0);

  const replyFormik = useFormik({
    initialValues: { reply: "" },
    validate: (values) => {
      const errors = {};
      if (!values.reply.trim()) errors.reply = "Message is required";
      return errors;
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        const res = await fetch(`${BASE_URL}/tenant-reply/${selectedReq._id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ reply: values.reply }),
        });

        const data = await res.json();

        if (!res.ok) {
          toast.error(data.message || "Failed to send message");
          return;
        }

        toast.success("Message sent successfully");

        setReplyModal(false);
        resetForm();
        dispatch(GetAllTenantMaintenanceRequest({ tenantId, flatId }));
      } catch (err) {
        toast.error("Server error");
      }
    },
  });

  // ---------- Fetch maintenance requests ----------
  // const fetchRequests = async () => {
  //   try {
  //     setLoadingRequests(true);
  //     const [tenantId, flatId] = getId.split("/"); // tenantId / flatId
  //     const res = await fetch(
  //       `${BASE_URL}/get-maintenance-request/${tenantId}/${flatId}`,
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  //     const data = await res.json();
  //     if (!res.ok) throw new Error(data.message || "Failed to fetch requests");
  //     setRequests(data.data || []);
  //   } catch (err) {
  //     toast.error("Failed to fetch maintenance requests", { position: "top-right", autoClose: 3000 });
  //   } finally {
  //     setLoadingRequests(false);
  //   }
  // };

  // useEffect(() => { fetchRequests(); }, [getId]);
  useEffect(() => {
    // if (getId) {
    // const [tenantId, flatId] = getId.split("/");
    dispatch(GetAllTenantMaintenanceRequest({ tenantId, flatId }));
    // }
  }, [dispatch, tab, tenantId, flatId]);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  // ---------- Formik ----------
  const formik = useFormik({
    initialValues: {
      category: "",
      description: "",
      urgency: "",
      media: [],
      previews: [],
    },
    validationSchema: maintenanceRequestValidationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        const formData = new FormData();
        formData.append("category", values.category);
        formData.append("description", values.description);
        formData.append("urgency", values.urgency);
        formData.append("status", "pending");

        const [landlordId, flatId] = getId.split("/");
        formData.append("landlordId", landlordId);
        formData.append("flatId", flatId);

        values.media.forEach((file) => formData.append("media", file));

        // ✅ Correct call
        await dispatch(MaintenanceRequestTenant(formData)).then((res) => {
          if (res?.payload?.success === true) {
            toast.success(res?.payload?.message);
          }
        });

        resetForm();
        setOpenModal(false);
        dispatch(GetAllTenantMaintenanceRequest({ tenantId, flatId }));
      } catch (err) {
        toast.error("Failed to submit maintenance request");
      } finally {
        setLoading(false);
      }
    },
  });
  useEffect(() => {
    if (!formik.values.selectedRequest?._id) return;
    if (!data?.data?.length) return;

    const reqId = formik.values.selectedRequest._id;

    setMessages((prev) => ({
      ...prev,
      [reqId]: data.data[0].chats || [],
    }));
    setChatLoading(false);
  }, [data, formik.values.selectedRequest]);
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const previews = files.map((f) => URL.createObjectURL(f));
    formik.setFieldValue("media", [...formik.values.media, ...files]);
    formik.setFieldValue("previews", [...formik.values.previews, ...previews]);
  };

  const handleRemoveMedia = (index) => {
    const updatedMedia = [...formik.values.media];
    const updatedPreviews = [...formik.values.previews];
    updatedMedia.splice(index, 1);
    updatedPreviews.splice(index, 1);
    formik.setFieldValue("media", updatedMedia);
    formik.setFieldValue("previews", updatedPreviews);
  };
  // ---------- Filtered requests by tab ----------
  const filteredRequests =
    tab === 0
      ? requests
      : requests?.filter((r) => r.status.toLowerCase() === statusLabels[tab]);
const checkAccept=requests?.filter((e)=>e.status.toLowerCase()==="accepted")

  const handleSendMessage = async () => {
    if (!chatMessage.trim()) return;

    const msgData = {
      senderId: userID,
      requestId: formik.values.selectedRequest?._id, //maintenance id
      message: chatMessage,
      timestamp: new Date(),
    };
    await dispatch(SendChat({ ...msgData }))
    // console.log(msgData, "msgData");
    // await axios.post(`${BASE_URL}/chat/send`, {
    //   ...msgData,
    // });
    // socket.emit("sendMessage", msgData);

    // setMessages((prev) => [...prev, msgData]);
    setChatMessage("");
  };
  useEffect(() => {
    const pusher = new Pusher("b7e67e30cdf802e24783", { cluster: "ap2" });
    setPusherClient(pusher);

    return () => {
      pusher.disconnect();
    };
  }, []);

  const handleOpenChatSidebar = async (req) => {
    setChatLoading(true);
    // const { data } = await axios.get(
    //   `${BASE_URL}/get-maintenance-request-chat/${req._id}`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("ots_token")}`,
    //     },
    //   }
    // );
    dispatch(GetAllMaintenanceRequestChat(req._id));
    formik.setValues({
      ...formik.values,
      selectedRequest: req,
      actionType: "message",
    });

    // setMessages((prev) => ({
    //   ...prev,
    //   [req._id]: data.data?.[0].chats || [],
    // }));

    setOpenChatSidebar(true);

    // Subscribe only if not already subscribed
    if (pusherClient && !pusherChannel) {
      const channel = pusherClient.subscribe(`chat-room-${req._id}`);
      channel.bind("message", (msg) => {
        setMessages((prev) => ({
          ...prev,
          [req._id]: [...(prev[req._id] || []), msg],
        }));
      });
      setPusherChannel(channel);
    }
  };

  // Function to close chat
  const handleCloseChatSidebar = () => {
    setOpenChatSidebar(false);
    const requestId = formik.values.selectedRequest?._id;

    if (pusherChannel && pusherClient) {
      pusherClient.unsubscribe(`chat-room-${requestId}`);
      setPusherChannel(null);
    }
  };

  const currentRequestId = formik.values.selectedRequest?._id;
  const currentMessages = messages[currentRequestId] || [];
  // --- Utility function for date groups ---
  const groupMessagesByDate = (messages) => {
    const groups = {};

    messages.forEach((msg) => {
      const date = new Date(msg.timestamp);
      const dateKey = date.toDateString(); // e.g. "Mon Nov 17 2025"

      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(msg);
    });

    return groups;
  };

  // --- Utility for heading (Today, Yesterday, or date) ---
  const formatDateHeading = (dateString) => {
    const msgDate = new Date(dateString);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (msgDate.toDateString() === today.toDateString()) {
      return "Today";
    }
    if (msgDate.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    }

    return msgDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleAction = (req, type) => {
    formik.setValues({
      ...formik.values,
      selectedRequest: req,
      actionType: type,
    });
  
      setOpenIssueResolved(true); // open new confirmation modal
   
  };
  const handleSubmitResolvedWithRating = async () => {
    try {
      const req = formik.values.selectedRequest;
  
      const requestObject = {
        ...req,
        status: "completed",
        reply: "",
        actionType: "completed",
        rating,
      };
  
      // const payload = { payload: requestObject }; // 👈 important
  
      // console.log("FINAL PAYLOAD >>> ", payload);
  
      await dispatch(RequestResponseLandlord(requestObject)).unwrap();
  
      toast.success("Issue marked as resolved!");
  
      setOpenIssueResolved(false);
      setRating(0);
  
      dispatch(GetAllTenantMaintenanceRequest({ tenantId, flatId }));
  
    } catch (err) {
      toast.error("Failed to update request");
    }
  };
  
  
  
  return (
    <>
      <Wrapper open={open} mylocation={mylocation} />
      <div className={`${open ? "sidebar-open" : "sidebar-closed"} `}>
        <Breadcrumbs>
          <Link color="inherit" to="/tenant-dashboard">
            Home
          </Link>
          <Link color="inherit" to={`/tenant-functionality/${getId}`}>
            Tenant Functionality
          </Link>
          <Link color="inherit" to={`/tenant-maintenance-request/${getId}`}>
            Maintenance Requests
          </Link>
        </Breadcrumbs>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          <Typography variant="h5">Maintenance Requests</Typography>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={() => setOpenModal(true)}
          >
            Add New Request
          </Button>
        </Box>

        {/* ---------- Tabs ---------- */}
        <Tabs value={tab} onChange={handleTabChange} sx={{ mt: 2 }}>
          <Tab label="All" />
          <Tab label="Pending" />
          <Tab label="Accepted" />
          <Tab label="Completed" />
          <Tab label="Rejected" />
        </Tabs>
        {/* ---------- Table ---------- */}
        {loadingRequests || requestSendLoading ? (
          <Box display="flex" justifyContent="center" mt={3}>
            <CircularProgress />
          </Box>
        ) : filteredRequests === undefined ? (
          <RecordNotFound />
        ) : (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Category</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Urgency</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Media</TableCell>
                  <TableCell>Reply</TableCell>
                  <TableCell>Rating</TableCell>
                  {checkAccept?.length>0?<TableCell>Action</TableCell>:""}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRequests?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} align="center">
                      No requests
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredRequests?.map((req) => (
                    <TableRow key={req._id}>
                      <TableCell>{req.category}</TableCell>
                      <TableCell>
                        <DescriptionCell description={req.description} />
                      </TableCell>
                      <TableCell>{req.urgency}</TableCell>
                      <TableCell>
                        <Chip
                          label={req.status}
                          color={
                            req.status.toLowerCase() === "pending"
                              ? "warning"
                              : req.status.toLowerCase() === "accepted"
                                ? "success"
                                : req.status.toLowerCase() === "rejected"
                                  ? "error"
                                  // : req.status.toLowerCase() === "in-progress"
                                  //   ? "info"
                                    : req.status.toLowerCase() === "completed"
                                      ? "success"
                                      : "default"
                          }
                        />
                      </TableCell>
                      <TableCell>
  {req.media && req.media.length > 0 ? (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      {/* Thumbnail (always first image) */}
      <img
        src={req.media[0].fileUrl || req.media[0].fileName}
        alt="thumbnail"
        onClick={() => {
          setZoomImages(req.media.map(m => m.fileUrl || m.fileName));
          setZoomIndex(0);
          setZoomOpen(true);
        }}
        style={{
          width: 45,
          height: 45,
          objectFit: "cover",
          borderRadius: 6,
          cursor: "pointer",
        }}
      />

      {/* Count Badge (only if more than 1 image) */}
      {req.media.length > 1 && (
        <Box
          sx={{
            position: "absolute",
            bottom: -8,
            right: -8,
            background: "#1976d2",
            color: "white",
            width: 22,
            height: 22,
            borderRadius: "50%",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid white",
          }}
        >
          +{req.media.length - 1}
        </Box>
      )}
    </Box>
  ) : (
    "-"
  )}
</TableCell>


                      <TableCell>
                        {req?.status==="pending"?"-":<DescriptionCell description={req.reply} />}
                      </TableCell>
                      <TableCell>
                      {(req?.status==="rejected"||req?.status==="pending")?"-":<Rating value={Number(req?.rating) || 0} readOnly precision={1} />}
                      </TableCell>
                      <TableCell> 
                        {/* If message already available → show message */}
                        {req.status?.toLowerCase() === "accepted" ? (
                          <>
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleOpenChatSidebar(req)}
                            sx={{ mr: 1 }}
                          >
                            Open Chat
                          </Button>

                          <Button
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={() => handleAction(req, "accepted")}
                              >
                                Issue Resolved
                              </Button>
                          </>
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            {/* No message */}
                          </Typography>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* ---------- Modal Form ---------- */}
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              p: 3,
              borderRadius: 2,
              width: { xs: "95%", sm: 500, md: 650 },
              maxHeight: "90vh",
              overflowY: "auto",
            }}
          >
            <Typography variant="h6" mb={2} sx={{ fontWeight: 600 }}>
              Add New Maintenance Request
            </Typography>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={
                      formik.touched.category && Boolean(formik.errors.category)
                    }
                  >
                    <InputLabel>Category</InputLabel>
                    <Select
                      name="category"
                      value={formik.values.category}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {[
                        "Electrical",
                        "Plumbing",
                        "Cleaning",
                        "Appliance",
                        "Internet",
                        "Structural",
                        "Other",
                      ].map((opt) => (
                        <MenuItem key={opt} value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </Select>

                    {formik.touched.category && formik.errors.category && (
                      <Typography variant="caption" color="error">
                        {formik.errors.category}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={
                      formik.touched.urgency && Boolean(formik.errors.urgency)
                    }
                  >
                    <InputLabel>Urgency</InputLabel>
                    <Select
                      name="urgency"
                      value={formik.values.urgency}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {["Normal", "Urgent", "Emergency"].map((opt) => (
                        <MenuItem key={opt} value={opt}>
                          {opt}
                        </MenuItem>
                      ))}
                    </Select>

                    {formik.touched.urgency && formik.errors.urgency && (
                      <Typography variant="caption" color="error">
                        {formik.errors.urgency}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    minRows={3}
                    label="Description"
                    name="description"
                    value={formik.values.description}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.description &&
                      Boolean(formik.errors.description)
                    }
                    helperText={
                      formik.touched.description && formik.errors.description
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button variant="outlined" component="label" fullWidth>
                    Upload Photo/Video
                    <input
                      type="file"
                      hidden
                      multiple
                      accepted="image/*,video/*"
                      onChange={handleFileChange}
                    />
                  </Button>
                  {formik.values.previews.length > 0 && (
                    <Box
                      sx={{ display: "flex", flexWrap: "wrap", mt: 1, gap: 1 }}
                    >
                      {formik.values.previews.map((src, idx) => (
                        <Box
                          key={idx}
                          sx={{
                            width: 60,
                            height: 60,
                            borderRadius: 2,
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <img
                            src={src}
                            alt={`preview-${idx}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveMedia(idx)}
                            sx={{
                              position: "absolute",
                              top: 2,
                              right: 2,
                              background: "rgba(0,0,0,0.6)",
                              color: "white",
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Submit Request"
                    )}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Modal>
        <Modal open={replyModal} onClose={() => setReplyModal(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              p: 3,
              borderRadius: 2,
              width: 400,
            }}
          >
            <Typography variant="h6" mb={2}>
              Chat
            </Typography>

            {/* 🔵 CHAT MESSAGES BOX */}
            <Box
              sx={{
                maxHeight: 250,
                overflowY: "auto",
                border: "1px solid #ddd",
                p: 1.5,
                borderRadius: 2,
                mb: 2,
              }}
            >
              {activeChat?.messages?.length > 0 ? (
                activeChat.messages.map((m, i) => (
                  <Box
                    key={i}
                    sx={{
                      textAlign: m.sender === "owner" ? "right" : "left",
                      mb: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        display: "inline-block",
                        p: 1,
                        background:
                          m.sender === "owner" ? "#d1f5d3" : "#e8e8e8",
                        borderRadius: 1,
                        maxWidth: "80%",
                      }}
                    >
                      {m.text}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography color="text.secondary" textAlign="center">
                  No messages yet
                </Typography>
              )}
            </Box>

            {/* 🟢 INPUT (Formik Controlled) */}
            <form onSubmit={replyFormik.handleSubmit}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                label="Type your message"
                name="reply"
                value={replyFormik.values.reply}
                onChange={replyFormik.handleChange}
                onBlur={replyFormik.handleBlur}
                error={
                  replyFormik.touched.reply && Boolean(replyFormik.errors.reply)
                }
                helperText={
                  replyFormik.touched.reply && replyFormik.errors.reply
                }
              />

              <Button
                fullWidth
                sx={{ mt: 2 }}
                variant="contained"
                type="submit"
              >
                Send
              </Button>
            </form>
          </Box>
        </Modal>
        <Drawer
          anchor="right"
          open={openChatSidebar}
          onClose={handleCloseChatSidebar}
        >
          <Box
            sx={{
              width: { xs: 300, sm: 400 },
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            {/* Header with Close */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid #ddd",
              }}
            >
              <Typography variant="h6">Chat with Tenant</Typography>
              <IconButton onClick={handleCloseChatSidebar}>
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Messages */}
            <Box sx={{ flexGrow: 1, overflowY: "auto", p: 2 }}>

              {chatLoading ? (
                <Box sx={{ textAlign: "center", mt: 2 }}>
                  <CircularProgress size={25} />
                  <Typography variant="caption" display="block" mt={1}>
                    Loading messages...
                  </Typography>
                </Box>
              ) : (

                (!currentMessages || currentMessages.length === 0) ? (
                  <Typography color="text.secondary" textAlign="center">
                    No messages yet
                  </Typography>
                ) : (
                  /* 🟢 Step 3: Show grouped messages */
                  Object.entries(groupMessagesByDate(currentMessages)).map(
                    ([dateKey, msgs]) => (
                      <React.Fragment key={dateKey}>

                        {/* Date Heading */}
                        <Box sx={{ textAlign: "center", my: 2 }}>
                          <Typography
                            variant="body2"
                            sx={{
                              bgcolor: "#e0e0e0",
                              display: "inline-block",
                              px: 2,
                              py: 0.5,
                              borderRadius: 2,
                              fontWeight: 600,
                            }}
                          >
                            {formatDateHeading(dateKey)}
                          </Typography>
                        </Box>

                        {/* Messages */}
                        {msgs.map((msg, i) => {
                          const timeString = new Date(msg.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          });

                          return (
                            <Box
                              key={i}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems:
                                  msg.senderId === userID ? "flex-end" : "flex-start",
                                mb: 1.5,
                              }}
                            >
<Box
  sx={{
    p: 1.2,
    bgcolor:
      msg.senderId === userID
        ? "#DCF8C6"     // Sender bubble (your message - green)
        : "#FFFFFF",    // Receiver bubble (white like WhatsApp)
    color: "black",
    borderRadius: 2,
    maxWidth: "70%",
    boxShadow: 1,
    alignSelf: msg.senderId === userID ? "flex-end" : "flex-start",
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottomLeftRadius: msg.senderId === userID ? 16 : 4,
    borderBottomRightRadius: msg.senderId === userID ? 4 : 16,
  }}
>
  {msg.message}
</Box>



                              <Typography
                                variant="caption"
                                sx={{ mt: 0.3, opacity: 0.7 }}
                              >
                                {timeString}
                              </Typography>
                            </Box>
                          );
                        })}
                      </React.Fragment>
                    )
                  )
                )
              )}
            </Box>

            {/* Input + Send */}
            <Box sx={{ display: "flex", p: 2, gap: 1 }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Type message..."
                value={chatMessage}
                onChange={(e) => setChatMessage(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSendMessage();
                }}
              />
              <IconButton color="primary" onClick={handleSendMessage}>
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Drawer>
        <Modal 
  open={openIssueResolved} 
  onClose={() => setOpenIssueResolved(false)}
>
  <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "background.paper",
      p: 3,
      borderRadius: 2,
      width: { xs: "90%", sm: 400 },
      textAlign: "center",
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: "orange" }}>
      ⭐ Rate Your Experience
    </Typography>

    <Typography variant="body1" sx={{ mb: 2 }}>
      Please rate the issue resolution before completing the request.
    </Typography>

    <Box sx={{ mb: 3 }}>
      <Rating
        name="issue-rating"
        value={rating}
        onChange={(event, newValue) => {
          setRating(newValue);
        }}
        size="large"
      />
    </Box>

    {/* Buttons */}
    <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
      <Button
        variant="outlined"
        color="error"
        onClick={() => setOpenIssueResolved(false)}
      >
        Cancel
      </Button>

      <Button
        variant="contained"
        color="success"
        disabled={rating === 0}
        onClick={handleSubmitResolvedWithRating}
      >
        Submit
      </Button>
    </Box>
  </Box>
</Modal>

<ImageZoomModal
  open={zoomOpen}
  onClose={() => setZoomOpen(false)}
  images={zoomImages}
  index={zoomIndex}
  setIndex={setZoomIndex}
/>

        <ToastContainer />
      </div>
    </>
  );
}
